<template>
  <Dropdown class="form-group">
    <div class="input-group">
      <input v-model="date" class="form-control" type="text" aria-label="selected date" />
      <div class="input-group-btn">
        <button class="dropdown-toggle btn" type="button">
          <i class="glyphicon glyphicon-calendar"></i>
        </button>
      </div>
    </div>
    <template v-slot:dropdown>
      <li>
        <DatePicker v-model="date" :clear-btn="false" :limit-from="limitFrom" />
      </li>
    </template>
  </Dropdown>
</template>

<script setup lang="ts">
import { DatePicker, Dropdown } from "uiv";

const props = withDefaults(
  defineProps<{
    limitFrom?: string | null;
  }>(),
  {
    limitFrom: null,
  },
);
const date = defineModel();
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";
.form-group {
  vertical-align: initial;
}

.input-group {
  display: inline-block;

  .form-control {
    width: 120px;
  }
}

.input-group-btn {
  left: 1px;
  display: inline-block;
}
</style>
